import { DateTime } from "luxon";

import { ReturnDeadline, ReturnDeadlineTone } from "../../models/returns/IReturnsApi";
import classNames from "../../utils/classNames";
import { deadlineText } from "../../utils/returnsRules";

const toneClasses: Record<ReturnDeadlineTone, string> = {
  grey: "bg-gray-100 text-gray-700",
  amber: "bg-amber-100 text-amber-700",
  red: "bg-red-100 text-red-700",
};

interface DeadlineChipProps {
  deadline: ReturnDeadline | null | undefined;
  now: DateTime;
  /** Shown instead when no eBay deadline applies (e.g. "Expected Fri 30 Oct" with the tracking under it). */
  fallback?: { text: string; sub?: string };
}

/** The countdown that applies now, with eBay's exact date underneath. Grey, amber inside a day, red once overdue. */
export default function DeadlineChip({ deadline, now, fallback }: DeadlineChipProps) {
  const text = deadlineText(deadline, now);
  if (!text) {
    if (!fallback) return null;
    return (
      <div className="flex flex-col gap-0.5">
        <span className="text-[11px] text-gray-700">{fallback.text}</span>
        {fallback.sub && <span className="text-[11px] text-gray-500">{fallback.sub}</span>}
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-0.5">
      <span className={classNames("w-max rounded px-[7px] py-0.5 text-[11px] font-semibold", toneClasses[text.tone])}>{text.text}</span>
      <span className="text-[11px] text-gray-500">{text.sub}</span>
    </div>
  );
}
